$(document).ready(function () {
  $('.tags_show a').on('click', function (e) {
    e.preventDefault();
    $(this).text($('.akkordion_m').toggleClass('open_akkordion_m').hasClass('open_akkordion_m') ? 'Скрыть категории' : 'Все категории');
  })

  $('.brand_show a').on('click', function (e) {
    e.preventDefault();
    $(this).text($('.akkordion_b').toggleClass('open_akkordion_b').hasClass('open_akkordion_b') ? 'Скрыть бренды' : 'Все бренды');
  })

  $('.region_show a').on('click', function (e) {
    e.preventDefault();
    $(this).text($('.akkordion_r').toggleClass('open_akkordion_r').hasClass('open_akkordion_r') ? 'Скрыть регионы' : 'Все регионы');
  })

  // Remove empty <p> tags (wordpress trash)
  $('p:empty').remove();

  // Forms
  $('.header__callback').magnificPopup({
    type: 'inline',
    midClick: true
  });

  $('.yacht-button__subscribe').magnificPopup({
    type: 'inline',
    midClick: true
  });

  $('.yacht-button__callback').magnificPopup({
    type: 'inline',
    midClick: true
  });
  $('.yacht-button__testdrive').magnificPopup({
    type: 'inline',
    midClick: true
  });

  // Mobile hamburger
  $('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.navigation > .navigation__list').toggleClass('open');
    $('body').toggleClass('no-scroll');
  });

  $('.scrollup').click(function () {
    // переместиться в верхнюю часть страницы
    $("html, body").animate({
      scrollTop: 0
    }, 1000);
  })

  $(window).scroll(function () {
    // если пользователь прокрутил страницу более чем на 200px
    if ($(this).scrollTop() > window.innerHeight * 3) {
      // то сделать кнопку scrollup видимой
      $('.scrollup').fadeIn();
    }
    // иначе скрыть кнопку scrollup
    else {
      $('.scrollup').fadeOut();
    }
  })

  $('.whatsapp-link').on('click', function () {
    $('#chat-24-icon-2').trigger('click');
  })

  // track submissions
  document.addEventListener('wpcf7mailsent', function (event) {
    fbq('track', 'SubmitApplication');
  }, false);

  //track contact clicks
  $('a[href^="tel:"],a[href^="mailto:"]').on('click', function () {
    fbq('track', 'Contact');
  });

  // contacts swiper
  if (document.querySelectorAll('.team-wrapper') !== null && $('.team-wrapper').length > 0 && window.innerWidth < 767) {
    $('.team-wrapper').css('flex-wrap', 'wrap');

    new Swiper(".teamSwiper", {
      direction: 'horizontal',
      loop: true,
      effect: 'slide',
      speed: 800,
      autoHeight: true,
      roundLengths: true,
      preloadImages: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });

    $('.team-wrapper').css('flex-wrap', 'nowrap');
  }
});

// Analytics Events  
document.addEventListener('wpcf7mailsent', function (event) {
  var actionName = {
    2250: 'Callback form',
    2252: 'Testdrive form',
    2254: 'Contact form',
    2249: 'Subscribe form'
  }

  var manager = document.getElementById('manager_service') > 0 ? document.getElementById('manager_service').innerHTML : '';
  var formID = event.detail.contactFormId;
  var formName = actionName[formID];
  var inputs = event.detail.inputs;
  var currentURL = window.location.href;

  $.post(directory_uri.stylesheet_directory_uri + "/bitrix24.php", {
    formID: formID,
    formName: formName,
    currentURL: currentURL,
    manager: manager,
    inputs: inputs
  });

  window.dataLayer.push({
    "event": "GAevent",
    'eventCategory': 'SendForm',
    'eventAction': formName,
    "formId": formID,
    // "response": event.detail.inputs,
    "url": currentURL
  });
  // Success message
  var formIDWrapper = event.detail.id;
  $('#' + formIDWrapper).html('<div class="form-success"><div class="form-success__header">Спасибо за заявку</div><div class="form-success__message">Наш менеджер свяжется с вами в ближайшее время</div><div class="form-success__logo"></div></div>');
});


if (document.querySelectorAll('section.yachts') !== null && $('section.yachts').length > 0) {
  (function () {
    var loading = false,
      container = $('section.yachts'),
      loader = $('.loader'),
      pagination = $('.yachts ~ .pagination');
    loader.hide();

    $("#filterForm").on('submit', function (e) {
      e.preventDefault();
      $.ajax({
        type: 'post',
        url: window.location.pathname + '?' + $(this).serialize(),
        //data: $(this).serialize(),
        dataType: 'html',
        cache: false,
        beforeSend: function (xhr, settings) {
          container.html(null);
          container.hide();
          loader.fadeIn();
          loading = true;
        },
        success: function (data, status, xhr) {
          var content = $(data).find('section.yachts').children(),
            newpagination = $(data).find('.pagination');

          content.appendTo(container);
          pagination.html(newpagination);
        },

        error: function (xhr, errorType, error) {
          console.log('error while loading yachts');
        },
        complete: function (xhr, status) {
          container.show();
          Waypoint.refreshAll();
          loading = false;
          loader.fadeOut();
          $('.filter__buttons').toggle($('section.yachts').find('.yacht-card').length > 0)
        }
      })

      return false;
    });

    $('.filter__buttons-btn').on('click', function (e) {
      e.preventDefault();

      var $btn = $(this), $frm = $('#filterForm')

      if ($btn.hasClass('active')) {
        $btn.toggleClass('desc');
      } else {
        $('.filter__buttons-btn').removeClass('active');
        $btn.addClass("active");
      }

      $frm.find('input[name=sort]').val($btn.attr('id'))
      $frm.find('input[name=sb]').val(+$btn.hasClass('desc'))

      $.ajax({
        type: 'post',
        url: window.location.pathname + '?' + $frm.serialize(),
        dataType: 'html',
        cache: false,
        beforeSend: function (xhr, settings) {
          container.html(null);
          container.hide();
          loader.fadeIn();
          loading = true;
        },
        success: function (data, status, xhr) {
          var content = $(data).find('section.yachts').children(),
            newpagination = $(data).find('.pagination');

          loader.fadeOut();
          content.appendTo(container);
          pagination.html(newpagination);
        },

        error: function (xhr, errorType, error) {
          console.log('error while loading yachts');
        },
        complete: function (xhr, status) {
          container.show();
          Waypoint.refreshAll();
          loading = false;
          $('.filter__buttons').toggle($('section.yachts').find('.yacht-card').length > 0)
        }
      })

      return false;
    });
    $('#more').click(function () {
      loadNextYachts();
    });
    function loadNextYachts(url) {
      var nextpage = typeof url === 'undefined'
        ? $(document).find('.next.page-numbers')
        : url;

      if ($(document).find('.next.page-numbers').length) {
        $.ajax({
          type: 'post',
          url: nextpage.attr('href'),
          dataType: 'html',
          cache: false,
          beforeSend: function (xhr, settings) {
            loader.fadeIn();
            loading = true;
          },
          success: function (data, status, xhr) {
            var nextpage = $(data).find('.next.page-numbers').attr('href');

            if (typeof nextpage !== 'undefined') {
              loading = false
            }

            var content = $(data).find('.yacht-card'),
              newpagination = $(data).find('.pagination');

            content.appendTo(container);
            pagination.html(newpagination);
          },
          error: function (xhr, errorType, error) {
            console.log('error while loading yachts');
          },
          complete: function (xhr, status) {
            loader.fadeOut();
            Waypoint.refreshAll();
          }
        })
      }
    }
  }());
}

// Single Yacht Plan Slider (Swiper settings)
if (document.querySelectorAll('.yacht-plans') !== null) {
  var planSwitcher = new Swiper('.yacht-plans-container', {
    pagination: {
      type: 'bullets',
      clickable: true,
      el: '.plan-pagination',
      renderBullet: function (index, className) {
        var planNames = document.querySelectorAll(".yacht-plans-switcher ul li");
        return '<span class="' + className + '">' + (planNames[index].innerHTML) + '</span>';
      },
    },
    direction: 'horizontal',
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 600,
    threshold: 5,
    preloadImages: false,
    lazy: true,
  });
}

var thumbnailsSettings = {
  nested: true,
  spaceBetween: 0,
  observer: true,
  observeParents: true,
  slideToClickedSlide: true,
  lazy: {
    loadPrevNext: true,
    preloaderClass: 'sunseeker-lazy-loader'
  },
  preloadImages: true,
  slidesPerView: 5,
  // freeMode: false,
  shortSwipes: false,
  breakpoints: {
    736: {
      slidesPerView: 3
    }
  }
};

if (document.querySelectorAll('.gallery-container') !== null &&
  $('.gallery-container').length > 0) {
  var switcherSettings = {
    effect: 'slide',
    observer: true,
    observeParents: true,
    simulateTouch: false,
    autoHeight: true,
    roundLengths: true,
    preventClicks: false,
    pagination: {
      type: 'bullets',
      clickable: true,
      el: '.yacht-gallery-selector',
      renderBullet: function (index, className) {
        var galleryNames = document.querySelectorAll(".yacht-gallery-selector ul li");
        return '<span class="' + className + '">' + (galleryNames[index].innerHTML) + '</span>';
      },
    },
  };

  var galleryContainer = new Swiper('.gallery-container', switcherSettings);

  galleryContainer.on('slideChange', function () {
    console.log('slide changed');
    galleryContainer.updateAutoHeight();

    function stop() {
      var iframe = document.querySelector('iframe');
      var video = document.querySelector('video');
      if (iframe !== null) {
        var iframeSrc = iframe.src;
        iframe.src = iframeSrc;
      }
      if (video !== null) {
        video.pause();
      }
    }
    stop();
  });

  var yachtThumbnails__exterior = new Swiper('.yacht-thumbnails__exterior', thumbnailsSettings);
  var yachtThumbnails__interior = new Swiper('.yacht-thumbnails__interior', thumbnailsSettings);
  var yachtGallery__exterior = new Swiper('.yacht-gallery__exterior', {
    direction: 'horizontal',
    nested: true,
    // loop: true, 
    observer: true,
    observeParents: true,
    effect: 'slide',
    speed: 800,
    autoHeight: true,
    roundLengths: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      preloaderClass: 'sunseeker-lazy-loader'
    },
    threshold: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: yachtThumbnails__exterior
    }
  });

  var yachtGallery__interior = new Swiper('.yacht-gallery__interior', {
    direction: 'horizontal',
    nested: true,
    // loop: true,
    observer: true,
    observeParents: true,
    effect: 'slide',
    speed: 800,
    autoHeight: true,
    roundLengths: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      preloaderClass: 'sunseeker-lazy-loader'
    },
    threshold: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: yachtThumbnails__interior
    }
  });
}
if (document.querySelectorAll('.yacht-gallery__merged') !== null &&
  $('.yacht-gallery__merged').length > 0) {
  var yachtThumbnails__merged = new Swiper('.yacht-thumbnails__merged', thumbnailsSettings);
  var yachtGallery__merged = new Swiper('.yacht-gallery__merged', {
    direction: 'horizontal',
    nested: true,
    loop: true,
    observer: true,
    observeParents: true,
    effect: 'slide',
    speed: 800,
    autoHeight: true,
    roundLengths: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      preloaderClass: 'sunseeker-lazy-loader'
    },
    threshold: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: yachtThumbnails__merged
    }
  });
}

// Front-Page Slider (Swiper settings)
if (document.querySelectorAll('.hero-slider') !== null) {
  var mySwiper = new Swiper('.hero-slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    effect: 'slide',
    speed: 800,
    autoHeight: true,
    roundLengths: true,
    // parallax: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      preloaderClass: 'sunseeker-lazy-loader'
    },

    pagination: {
      type: 'bullets',
      clickable: true,
      el: '.swiper-pagination',
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      },
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });
}


// Timeline Slider (Swiper settings)
if (document.querySelectorAll('.timeline-slider') !== null) {
  var mySwiper = new Swiper('.timeline-slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    effect: 'slide',
    speed: 800,
    autoHeight: true,
    // parallax: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      preloaderClass: 'sunseeker-lazy-loader'
    },

    pagination: {
      type: 'bullets',
      clickable: true,
      el: '.timeline-switcher',
      renderBullet: function (index, className) {
        var timelineYears = document.querySelectorAll(".timeline-switcher li");
        return '<span class="' + className + '">' + (timelineYears[index].innerHTML) + '</span>';
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });
}

// collapse es

var collapses = document.querySelectorAll('.yacht-collapse-header');
if (collapses.length > 0) {
  Array.prototype.forEach.call(collapses, function (el, i) {
    el.addEventListener('click', function (e) {
      var content = e.currentTarget.parentElement.querySelector('.yacht-collapse-content');
      var height = content.scrollHeight;
      e.currentTarget.classList.toggle('active');
      content.classList.toggle('open');
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = height + "px";
      }
    });
  });
}

var btnsCollapse = document.querySelectorAll('.btn-collapse');
if (btnsCollapse.length > 0) {
  Array.prototype.forEach.call(btnsCollapse, function (el, i) {
    el.addEventListener('click', function (e) {
      var content = e.currentTarget.parentElement.querySelector('div');
      var height = content.scrollHeight;
      e.currentTarget.classList.toggle('active');
      content.classList.toggle('open');
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = height + "px";
      }
    });
  });
}

if (document.querySelectorAll('#filter') !== null && $('#filter').length > 0) {
  ['length', 'price', 'year'].forEach(function (element) {
    var container = document.getElementById('yacht_' + element),
      currentMin = document.getElementById(element + '_min'),
      currentMax = document.getElementById(element + '_max'),
      rangeMin = document.getElementById(element + '_min').min,
      rangeMax = document.getElementById(element + '_max').max;

    if (rangeMin !== rangeMax) {
      noUiSlider.create(container, {
        start: [parseInt(currentMin.value), parseInt(currentMax.value)],
        connect: true,
        range: {
          'min': parseInt(rangeMin),
          'max': parseInt(rangeMax),
        }
      });

      container.noUiSlider.on('update', function (values, handle) {
        var value = values[handle],
          lblLeft = container.querySelector('.filter-slider__left-lbl'),
          lblRight = container.querySelector('.filter-slider__right-lbl'),
          price = wNumb({
            mark: '.',
            thousand: ' ',
            prefix: '',
            suffix: ''
          });

        if (handle) {
          if (lblRight)
            lblRight.innerText = container.id === 'yacht_price'
              ? price.to(parseInt(value))
              : value
        } else {
          if (lblLeft)
            lblLeft.innerText = container.id === 'yacht_price'
              ? price.to(parseInt(value))
              : value
        }
      })

      container.noUiSlider.on('change', function (values, handle) {
        var value = values[handle]
        if (handle) {
          currentMax.value = value;
        } else {
          currentMin.value = value;
        }
      })

      currentMin.addEventListener('change', function () {
        container.noUiSlider.set([this.value, null]);
      });

      currentMax.addEventListener('change', function () {
        container.noUiSlider.set([null, this.value]);
      });
    } else {
      container.classList.add('one-value');
      container.querySelectorAll('label').forEach(function (e, i) { e.innerText = rangeMin })
    }
  });

  var sliderYear = document.getElementById('yacht_year'),
    sliderLength = document.getElementById('yacht_length'),
    sliderPrice = document.getElementById('yacht_price');

  if (sliderYear.noUiSlider)
    sliderYear.noUiSlider.updateOptions({
      step: 1,
      format: wNumb({
        decimals: 0,
      })
    });

  sliderLength.noUiSlider.updateOptions({
    step: 1,
    format: wNumb({
      decimals: 0,
      suffix: ''
    })
  });

  if (sliderPrice.noUiSlider)
    sliderPrice.noUiSlider.updateOptions({
      step: 10000,
      format: wNumb({
        decimals: 0,
        suffix: ''
      })
    });

  document.querySelectorAll('[name=currency]').forEach(function (e) {
    e.addEventListener('change', function (x) {
      sliderPrice.noUiSlider.updateOptions({
        range: {
          'min': +x.target.dataset.min,
          'max': +x.target.dataset.max,
        }
      });
      sliderPrice.noUiSlider.set([x.target.dataset.min, x.target.dataset.max], true, true);
      document.getElementById('price_min').value = +x.target.dataset.min
      document.getElementById('price_max').value = +x.target.dataset.max
      document.getElementById('yacht_price_label').innerText = 'Цена (' + (document.querySelector('label[for=' + x.target.id + ']').innerText) + ')'
    })
  })
}

